import styled from '@slicknode/stylemapper';
import { ComponentProps, JSXElementConstructor } from 'react';
import { twMerge } from 'tailwind-merge';

export const Title = (props: ComponentProps<'h5'>) => {
  return (
    <h5
      {...props}
      className={twMerge(
        'xxs:pb-0 xxs:mb-1 dark:text-white-50',
        props.className
      )}
    />
  );
};
export const SubTitle = (props: ComponentProps<'p'>) => {
  return (
    <p
      {...props}
      className={twMerge(
        'xxs:text-xs dark:text-white-600 xxs:pb-0 xxs:mb-0',
        props.className
      )}
    />
  );
};

export const Card = ({
  md,
  as = 'div',
  size = 'base',
  ...props
}: ComponentProps<'div'> & {
  md?: boolean;
  as?: 'section' | 'div';
  size?: 'base' | 'xs';
}) => {
  const Component = as;
  return (
    <Component
      {...props}
      className={twMerge(
        'xxs:flex xxs:flex-col xxs:rounded-md h-full xxs:relative',
        md
          ? twMerge(
              'xxs:bg-inherit md:bg-black-800 md:shadow-md',
              size === 'xs' ? 'md:p-2' : 'md:p-4'
            )
          : twMerge(
              'xxs:bg-black-800  xxs:shadow-md',
              size === 'xs' ? 'xxs:p-2' : 'xxs:p-4'
            ),
        size === 'xs' ? 'space-y-1' : 'space-y-2',
        props.className
      )}
    />
  );
};

export type SubCardProps<
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
> = {
  md?: boolean;
  as?: T;
  size?: 'base' | 'xs';
} & ComponentProps<T>;

export const SubCard = <
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
>({
  md,
  as,
  size = 'base',
  ...props
}: SubCardProps<T>) => {
  const Component = as || ('div' as any);

  return (
    <Component
      {...props}
      className={twMerge(
        'xxs:flex xxs:flex-col xxs:w-full lg:rounded-md space-y-2 min-w-0 md:bg-black-700',

        md
          ? twMerge(
              'xxs:bg-inherit md:bg-white-100 md:shadow-md',
              size === 'xs' ? 'md:p-2' : 'md:p-4'
            )
          : twMerge(
              'xxs:bg-black-800 xxs:shadow-md',
              size === 'xs' ? 'xxs:p-2' : 'xxs:p-4'
            ),
        size === 'xs' ? 'space-y-1' : 'space-y-4',
        props.className
      )}
    />
  );
};

export const SubSubCard = (props: ComponentProps<'div'>) => {
  return (
    <div
      {...props}
      className={twMerge(
        'xxs:shadow xxs:bg-black-700 md:dark:bg-black-600 xxs:p-2 sm:p-4 xxs:rounded xxs:text-center xxs:flex-1',
        props.className
      )}
    />
  );
};

export const SubCardTitle = styled(
  'div',
  'xxs:font-normal dark:text-white-50',
  {
    variants: {
      size: {
        base: 'xxs:text-base',
        sm: 'xxs:text-sm',
        xl: 'xxs:text-xl',
      },
    },
    defaultVariants: {
      size: 'xl',
    },
  }
);
